import { Chip } from "kosmos-ui/lib";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const CompanyCategoriesContainer = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colorsPalette.black.default};
  padding: 72px;

  @media (max-width: 600px) {
    padding: 40px 24px;
  }
`;

export const CompanyCategoryContainer = styled.div`
  margin: auto;
  max-width: 1200px;
  width: 100%;
`;

export const CompanyCategoryLink = styled(Link)`
  color: ${({ theme }) => theme.colorsPalette.white.default};
  text-decoration: none;
  font-family: "SFPro";
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 16px 0;
  max-width: 380px;
  line-height: 1.1;
`;

export const CompanyCategoryTagsContainer = styled.div`
  display: flex;
  margin-top: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CompanyCategoryTagChip = styled(Chip)`
  opacity: 0.5;
`;

export const GroupedCompaniesGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 2fr));
  gap: 16px;
`;
